import { Box, Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { CustomerCartQuery } from "@saleor/graphql";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import useStyles from "./styles";

interface BoxInfoCustomerProps {
  data: CustomerCartQuery;
}

const BoxInfoContract: React.FC<BoxInfoCustomerProps> = ({ data }) => {
  const classes = useStyles({});
  const intl = useIntl();

  return (
    <Grid item xs={6} md={6}>
      <Box className={classes.boxCustomer}>
        <div className={classes.boxHeader}>
          <MyTypography variant={"body3"} className={classes.headerTitle}>
            {intl.formatMessage({ defaultMessage: "เลขที่ Contract" })}
          </MyTypography>
          <MyTypography variant={"h6"} className={classes.textWhite}>
            {data?.customerCart?.contract?.code}
          </MyTypography>
        </div>
        <div className={classes.boxBody}>
          <div className={classes.infoRow}>
            <div className={classes.infoLeft}>
              <MyTypography variant={"body3"}>
                <FormattedMessage defaultMessage={"ชื่อโครงการ"} />
              </MyTypography>
            </div>
            <div className={classes.infoRight}>
              <MyTypography variant={"subtitle3"}>
                {data?.customerCart?.contract?.projectName}
              </MyTypography>
            </div>
          </div>
        </div>
      </Box>
    </Grid>
  );
};

export default BoxInfoContract;
